import(/* webpackMode: "eager" */ "/app/next/app/(legacy)/error.tsx");
